module.exports = __webpack_public_path__ + "static/media/tapan_logo.b6c8d9e2.png";